import { Get, Post, Put, Delete } from "../../shared/services/Fetch";

export async function getTabConfig({
  activeTab,
  setLoading,
  token,
  notify
}: {
  activeTab: any;
  setLoading: Function;
  token: string;
  notify: Function;
}) {
  try {
    const { endpoint, method, body } = activeTab.api;
    setLoading(true);
    let configResponse;
    switch (method) {
      case "POST":
        configResponse = await Post(endpoint, token, body);
        break;
      case "GET":
        configResponse = await Get(endpoint, token);
        break;
      case "PUT":
        configResponse = await Put(endpoint, token, body);
        break;
      case "DELETE":
        configResponse = await Delete(endpoint, token);
        break;
      default:
        configResponse = {
          data: null,
          error: "Unsupported HTTP method",
          status: false,
          statusCode: 500
        };
        break;
    }
    if (configResponse.status) {
      return configResponse;
    } else {
      notify({
        title: "Error",
        text: configResponse.error || "Failed to fetch tab config data",
        type: "error"
      });
    }
  } catch (error) {
    console.error("Error calling API:", error);
    notify({
      title: "Error",
      text: error.message,
      type: "error"
    });
  } finally {
    setLoading(false);
  }
}
